// extracted by mini-css-extract-plugin
module.exports = {"about-page-layout":"style_about-page-layout__orHec","about-page-layout__logo":"style_about-page-layout__logo__jPO3_","page-title":"style_page-title__JemMh"};